var _path, _path2, _circle, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRxsp = function SvgRxsp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.208 12.918c.497-4.401 4.2-7.726 8.606-7.726H34.07c4.406 0 8.11 3.325 8.607 7.726l2.965 26.236c.52 4.592-3.053 8.615-7.65 8.615h-25.1c-4.596 0-8.168-4.023-7.65-8.615l2.966-26.236Z",
    fill: "url(#rxsp_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.403 11.423c0 2.969 2.256 5.376 5.04 5.376 2.783 0 5.039-2.407 5.039-5.376h2.749c0 4.588-3.487 8.308-7.789 8.308-4.301 0-7.788-3.72-7.788-8.308h2.749Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 14.001,
    y: 14,
    width: 49.702,
    height: 49.702
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#rxsp_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 12,
    cx: 38.851,
    cy: 38.851,
    r: 12.101,
    fill: "url(#rxsp_svg__c)",
    stroke: "url(#rxsp_svg__d)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.223 37.859V44.5h-2.178a.55.55 0 0 1-.545-.553v-5.535a.55.55 0 0 1 .545-.553h2.178Zm3.047-4.795c-.008-.37.317-.681.646-.52 1.829.893 1.427 3.821.937 5.315h2.375c.52 0 .974.374 1.028.898.39 3.829-1.156 5.743-3.403 5.743H37.04v-6.641c1.862-.757 2.265-3.184 2.23-4.795Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rxsp_svg__a",
    x1: 25.442,
    y1: 5.192,
    x2: 25.442,
    y2: 47.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rxsp_svg__c",
    x1: 38.851,
    y1: 26,
    x2: 38.851,
    y2: 51.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rxsp_svg__d",
    x1: 38.851,
    y1: 26,
    x2: 38.851,
    y2: 51.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1CCF9",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rxsp_svg__b",
    transform: "translate(-14 -14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.851,
    cy: 38.851,
    r: 12.101
  })))));
};

export default SvgRxsp;